__turbopack_context__.v({
  "livestream_player__iframe": "jEmm5a_livestream_player__iframe",
  "multi_livestream__app": "jEmm5a_multi_livestream__app",
  "multi_livestream__error__body": "jEmm5a_multi_livestream__error__body",
  "multi_livestream__error__container": "jEmm5a_multi_livestream__error__container",
  "multi_livestream__error__link": "jEmm5a_multi_livestream__error__link",
  "multi_livestream__error__title": "jEmm5a_multi_livestream__error__title",
  "multi_livestream__localization_message": "jEmm5a_multi_livestream__localization_message",
  "multi_livestream__player": "jEmm5a_multi_livestream__player",
  "multi_livestream__player__container": "jEmm5a_multi_livestream__player__container",
  "multi_livestream__player__loading": "jEmm5a_multi_livestream__player__loading",
  "multi_livestream__root": "jEmm5a_multi_livestream__root",
  "multi_livestream__schedule__loading": "jEmm5a_multi_livestream__schedule__loading",
  "multi_livestream__theme__light": "jEmm5a_multi_livestream__theme__light",
});
